// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CustomValidationItemDTO  {
    _originalTypeClassName = "Loom.BO.CustomValidationItemDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CustomValidationItemDTO.translate = translateService;
}
this.Message = null;
this.CustomValidationItemDTOKey = null;
this._key = this.CustomValidationItemDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Message:any;
private _CustomValidationItemDTOKey:any;
get CustomValidationItemDTOKey(): any {
    return this._CustomValidationItemDTOKey;
  }
set CustomValidationItemDTOKey(value: any) {
    this._CustomValidationItemDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CustomValidationItemDTOKey == null || $this.CustomValidationItemDTOKey == 0;
            }


}